
import { listUrl } from "../Data";
import { ImageCustom } from "../Image";
import {
  TrocSection,
  Trocvideo,
  TrocLogo,
  TrocTitle,
  TrocBackgoud,
  TrocWrapper,
  TrocBoxDescription,
  TrocBoxImgs,
  TrocText,
  TrocBoxTitle,
  TrocBoxLink,
  TrocBoxLinkText,
  TrocBoxLinkbtn,
} from "./style";


const TrocComponent = () => {

  return (
    <TrocSection id="TROC">
      <TrocLogo>
        <Trocvideo>
          <iframe
            src={listUrl.trocWrapper.video}
            width="815"
            height="460"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Economize 90% nas suas marcas favoritas com a TROC: o maior brechó online do Brasil."
          />
        </Trocvideo>
        <TrocBoxTitle>
          <ImageCustom src={listUrl.trocWrapper.logo} alt="" />
          <TrocTitle>O maior brechó online do Brasil.</TrocTitle>
        </TrocBoxTitle>
      </TrocLogo>
      <TrocBackgoud />
      <TrocWrapper>
        <TrocBoxDescription>
          <TrocText>A roupa mais sustentável é aquela que já existe!</TrocText>
          <TrocText>Um dos pilares mais importantes para ampliar a sustentabilidade do varejo é a aumentar o ciclo de vida dos produtos, o que reduz significativamente a geração de resíduos e a demanda por extração de matérias-primas virgens.</TrocText>
          <TrocText>Entrando com uma proposta totalmente diferente das demais marcas do grupo, a TROC é uma plataforma de second hand de marcas de moda premium e luxo. Mais conhecida como brechó, nossa plataforma online atua para transformar a cultura do consumo, fortalecendo a ideia de circularidade no mundo da moda.</TrocText>
          <TrocText>Clientes das marcas da Alme, Arezzo e Schutz também podem optar por receber, no momento da compra de seus produtos, uma TROC Bag para venderem as peças que não querem mais na TROC, dando a elas uma segunda vida.</TrocText>
          <TrocText>Em 2022, 10.900 produtos que estavam parados nos estoques das marcas do Grupo por serem itens de coleções passadas e/ou com pequenos defeitos, foram disponibilizados para venda na plataforma. Hoje os produtos Arezzo, Schutz e Alexandre Birman de coleções passadas podem ser adquiridos no site da TROC.</TrocText>
          <TrocText>Quer conhecer mais?</TrocText>
          <TrocBoxLink>
            <TrocBoxLinkText>Acesse:</TrocBoxLinkText>
            <TrocBoxLinkbtn href="https://troc.com.br/" target="_blank">troc.com.br</TrocBoxLinkbtn>
          </TrocBoxLink>
        </TrocBoxDescription>
        <TrocBoxImgs>
          <ImageCustom src={listUrl.trocWrapper.troc01} alt="" />
        </TrocBoxImgs>
      </TrocWrapper>
    </TrocSection>

  );
};

export default TrocComponent;
